/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of request that is sent to the user.
 * @export
 */
export const SendCompleteProfileRequestRequestType = {
    WorkExperiences: 'WorkExperiences',
    WorkExperienceDescriptions: 'WorkExperienceDescriptions',
    EducationExperiences: 'EducationExperiences'
};
export function instanceOfSendCompleteProfileRequestRequestType(value) {
    for (const key in SendCompleteProfileRequestRequestType) {
        if (Object.prototype.hasOwnProperty.call(SendCompleteProfileRequestRequestType, key)) {
            if (SendCompleteProfileRequestRequestType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SendCompleteProfileRequestRequestTypeFromJSON(json) {
    return SendCompleteProfileRequestRequestTypeFromJSONTyped(json, false);
}
export function SendCompleteProfileRequestRequestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SendCompleteProfileRequestRequestTypeToJSON(value) {
    return value;
}
export function SendCompleteProfileRequestRequestTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
